import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
 
export default function FileGambar(props) {
    let {url}=props
    return(
        <LazyLoadImage
            alt="asdf"
            // src="https://www.onegml.com/assets/events/444/bx2ocery.x5c.jpg" // use normal <img> attributes as props
            src={url}
            width="100%"
            effect="blur"
        />
    )

}
